<template>
    <div>
        <div class="text-center my-4 p-4 p-md-5">
            <h1>
                HEY
                <span class="stroke-light text-dark">COACH</span>
            </h1>
            <h4>
                Ladder Coach ties together the tools for fitness professionals
                <br class="d-none d-md-inline" />to offer world-class digital &amp; in-person coaching
            </h4>
            <div class="p-4">
                <v-button
                    @click="scrollTo('contact')"
                    size="lg"
                    upper
                    variant="outline-light"
                >Learn More</v-button>
            </div>
        </div>
        <ValuePropsCarousel animate audience="coach" class="bg-dark mb-5" />
        <v-container class="bg-white" fluid ref="contact">
            <v-row>
                <v-column class="p-5 text-dark" cols="12" md="6">
                    <h1>
                        Let's
                        <span class="stroke-dark text-white">Talk</span>
                    </h1>
                    <h4>We'd love to hear more about your interest in using Ladder Coach.</h4>
                </v-column>
                <v-column class="p-5" cols="12" md="6">
                    <h4 class="text-dark mb-3">Contact us</h4>
                    <contact-form context="coach" />
                </v-column>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import ValuePropsCarousel from "@/components/ValuePropsCarousel";
import ContactForm from "@/components/ContactForm";

export default {
    name: "IndexCoachView",
    components: {
        ValuePropsCarousel,
        ContactForm
    },
    methods: {
        scrollTo(ref) {
            window.scroll({
                top:
                    window.scrollY +
                    this.$refs[ref].$el.getBoundingClientRect().top,
                left: 0,
                behavior: "smooth"
            });
        }
    }
};
</script>